import { atom } from 'recoil';

// WebSocketインスタンスを格納するRecoilのAtom
export const websocketState = atom<WebSocket | null>({
  key: 'websocketState',
  default: null, // 初期値はnull、後でWebSocketインスタンスをセット
});
